import { CloseCircleOutlined, UploadOutlined } from "@ant-design/icons"
import { Button, Col, Divider, Input, Row, Select, Space, Typography, Upload } from "antd"
import React from "react"

const { Text } = Typography

export default function TapePriceSection({
  disableTapeSave,
  tapePrices,
  createNewTapeProduct,
  setTapePrices,
  tapeFile,
  setTapeFile,
  tapeButtonLoading,
  tapeWidth,
  tapeOptions,
}) {
  //handles adding amount
  const handleAddAmount = () => {
    setTapePrices([
      ...tapePrices,
      { label: "0 rolls", rolls: 0, price: 0.0, boxCount: 0, weight: 0 },
    ])
  }

  const handleAmountChange = (index, value, option) => {
    const values = [...tapePrices]
    const currentObject = {
      label: option.label,
      rolls: option.rolls,
      price: option.price,
      boxCount: option.boxCount,
      weight: 0,
    }
    //replaces current index object with the new one
    values[index] = currentObject // Update the current object in the values array
    setTapePrices(values) // Update the state with the modified values array
  }

  //handles removing amount
  const removeAmountFields = (index) => {
    const values = [...tapePrices]
    values.splice(index, 1)
    setTapePrices(values)
  }

  return (
    <>
      <Row
        style={{ paddingRight: 45, paddingLeft: 45, paddingBottom: 45 }}
        align="middle"
        gutter={[2, 5]}>
        {tapePrices && tapePrices.length !== 0 ? (
          <>
            <Col flex={1}>
              <Text>Count</Text>
            </Col>
            <Col flex={1}>
              <Text>Price</Text>
            </Col>
            <Col flex={2}>
              <Text>Boxes</Text>
            </Col>
          </>
        ) : (
          ""
        )}
        {tapePrices && tapePrices.length !== 0
          ? tapePrices.map((inputField, index) => (
              <div key={index}>
                <Row justify="end" align="middle">
                  <Col span={20}>
                    <Space.Compact block>
                      <Select
                        style={{ width: "33%" }}
                        fieldNames={{ label: "label", value: "rolls", price: "price" }}
                        name="label"
                        options={tapeOptions} //Tape options are being set when the tape width is chosen
                        value={inputField.label}
                        onChange={(value, options) => handleAmountChange(index, value, options)} // Updated parameter name to value
                      />
                      <Input
                        style={{ width: "33%" }}
                        value={isFinite(inputField.price) ? inputField.price : 0}
                      />
                      <Input
                        style={{ width: "33%" }}
                        value={isFinite(inputField.boxCount) ? inputField.boxCount : 0}
                      />
                    </Space.Compact>
                  </Col>
                  <Col span={4}>
                    <Button type="primary" ghost danger onClick={() => removeAmountFields(index)}>
                      <CloseCircleOutlined />
                    </Button>
                  </Col>
                </Row>
              </div>
            ))
          : ""}
        <Button type="dashed" block onClick={() => handleAddAmount()}>
          Add More Tape Prices
        </Button>

        <Divider />

        <Space split={<Divider type="vertical" />}>
          <Text> Tape File :</Text>
          <Upload
            beforeUpload={(file) => {
              setTapeFile(file) // Set the file to state
              return false // This is to prevent AntD from auto-uploading the file
            }}>
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </Space>

        <Divider />

        <Button
          loading={tapeButtonLoading}
          disabled={disableTapeSave}
          style={{ marginTop: "5px" }}
          onClick={() => createNewTapeProduct()}
          block>
          Save Product
        </Button>
      </Row>
    </>
  )
}
